// extracted by mini-css-extract-plugin
export default {"scope":"mzI44","my-assets":"+s+kL","upload-hint":"D19fu","list":"Nb-+4","no-records":"toqVh"};